import React from "react";
import { Button } from 'antd';
import "./buttons.scss";
import Lottie from "lottie-react";
import groovyWalkAnimation from "../../../styles/images/br-login-animated-dots.json";
type buttonProps = {
  type?: any;
  name?: any;
  className?: any;
  icon?: any;
  onClick?: any;
  htmlType?:any;
  disabled?:any;
};

type buttonState = {

};
class URButton extends React.Component<buttonProps, buttonState> {

  constructor(props: any) {
    super(props);
    this.state = {

    };
  }

  render() {
    return (
      <>
        <Button disabled={this.props.disabled}
          id="generalbtn" onClick={this.props.onClick} htmlType={this.props.htmlType}
          className={this.props.className}
          type={this.props.type ? this.props.type : 'primary'}>
          {this.props.icon && <span className={this.props.icon}></span>}
          <span> {this.props.name?this.props.name:<Lottie style={{"width":50}}
            animationData={groovyWalkAnimation} />}</span>
        </Button>
      </>
    );
  }

}

export {
  URButton
};

